"use client";

import { Button } from "@repo/ui";
import Link from "next/link";

import { useCookieConsent } from "./cookie-consent-context";

export function CookieConsentBanner() {
  const { mounted, region, choice, acceptAll, rejectAll, openPreferences } =
    useCookieConsent();

  // Only shown to in-region visitors who have not yet made a choice.
  if (!mounted || region !== "required" || choice) {
    return null;
  }

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 p-4 sm:p-6"
    >
      <div className="border-border bg-card mx-auto flex max-w-3xl flex-col gap-4 rounded-xl border p-5 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-muted-foreground text-sm">
          We use cookies to run Terac, measure usage, and improve your
          experience. You can accept all cookies, reject non-essential ones, or
          choose what to allow. See our{" "}
          <Link
            href="/legal/cookie-policy"
            className="text-foreground underline underline-offset-4"
          >
            Cookie Policy
          </Link>
          .
        </p>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-center">
          <Button variant="ghost" size="sm" onClick={openPreferences}>
            Manage preferences
          </Button>
          <Button variant="outline" size="sm" onClick={rejectAll}>
            Reject all
          </Button>
          <Button size="sm" onClick={acceptAll}>
            Accept all
          </Button>
        </div>
      </div>
    </div>
  );
}
